import {Box, Row} from "@cdx/ds";
import {ArenaCtx} from "../../card-panel/card-panel-utils";
import {forwardRef} from "react";
import {GroupedActivityItem} from "../shared";
import {
  DSDiscordConvoAwareAvatar,
  DSDiscordCreatedAwareAvatar,
} from "../../card-container/sidebars/conversations/convo-utils";
import {api} from "../../../lib/api";

type FeedEntryProps = {
  data: GroupedActivityItem;
  isFirst: boolean;
  user: any;
  arenaCtx: ArenaCtx;
  root: any;
};
const FeedEntry = forwardRef<HTMLElement, FeedEntryProps>((props, ref) => {
  const {isFirst, data, user, arenaCtx, root} = props;
  const {firstItem, isComment, Comp} = data;

  return (
    <Row sp="12px" align="center" ref={ref}>
      <Box flex="none" width="24px">
        {isFirst ? (
          isComment ? (
            <DSDiscordConvoAwareAvatar
              card={firstItem.card}
              resolvable={api.getModel({
                id: (firstItem.data as any).resolvableId,
                modelName: "resolvable",
              })}
              user={user}
            />
          ) : (
            <DSDiscordCreatedAwareAvatar card={firstItem.card} user={user} />
          )
        ) : null}
      </Box>
      <Box
        flex="auto"
        relative
        color="primary"
        bg="foreground"
        px="12px"
        py="8px"
        minWidth="0"
        rounded={4}
      >
        <Comp values={data.values} arenaCtx={arenaCtx} firstItem={firstItem} root={root} />
      </Box>
    </Row>
  );
});

export default FeedEntry;
